import type { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import { store } from './store';

/**
 * Провайдер Redux хранилища
 * Оборачивает приложение для предоставления доступа к состоянию
 */
export function StoreProvider({ children }: PropsWithChildren<{}>) {
  return <Provider store={store}>{children}</Provider>;
}
